import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "./FirebaseConfig";

const AdminRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null); // ← ← ← 最初は null にするのが重要！

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log("👤 onAuthStateChanged → user:", user);
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      setUser(user);

      try {
        const docRef = doc(db, "users", user.uid);
        const snap = await getDoc(docRef);
        console.log("📄 Firestore exists:", snap.exists());
        console.log("📦 Firestore data:", snap.data());

        const role = snap.data()?.role;
        console.log("🧾 role:", role);

        if (role === "admin") {
          console.log("✅ 管理者です！");
          setIsAdmin(true);
        } else {
          console.log("❌ 管理者ではありません");
          setIsAdmin(false);
        }
      } catch (e) {
        console.error("🔥 getDoc error:", e);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // 🛑 ロード中 or 判定中は絶対に何も返さない！
  if (loading || isAdmin === null) {
    return <div>Checking permissions...</div>;
  }

  // ⛔ 管理者じゃなかったらリダイレクト
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // ✅ 管理者だけがここに到達できる
  return children;
};

export default AdminRoute;
